export default __webpack_public_path__ + "static/media/mc_lid_open.78c7c036.svg";